import { useCallback } from 'react';

import { markLatestRegistryResultStale } from '@app/pages/Leads/model/latestRegistryResultSlice';
import { useAppDispatch } from '@app/store';

// Flags the accepted registry result as stale without subscribing to it (no
// `useAppSelector`). Used outside the registry (e.g. the Lead Card) after a
// change the registry cannot observe in place — a task created or completed —
// so the registry refetches on its next mount instead of reusing the cached
// result. Mirrors `useReplaceLatestRegistryLead`.
export const useMarkLatestRegistryResultStale = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(markLatestRegistryResultStale());
  }, [dispatch]);
};
